import React from "react";
import { IAppealSubmissionProps } from "../../model/interface";
import { AppealType } from "../../model/enum";
import AccountAppealSubmission from "./AccountAppealSubmission";
import ContentAppealSubmission from "./ContentAppealSubmission";

export default function AppealSubmission(props: IAppealSubmissionProps) {
    return (
        <React.Fragment>
            {props.appealType === AppealType.Account &&
                <AccountAppealSubmission
                    appealNumber={props.appealNumber}
                    appealDate={props.appealDate}
                    appealerName={props.appealerName}
                    userId={props.userId ? props.userId : ""}
                    contactEmail={props.contactEmail}
                    isNewSubmission={props.isNewSubmission}
                    isUpdatedSubmission={props.isUpdatedSubmission}
                    />
            }
            {props.appealType === AppealType.Content &&
                <ContentAppealSubmission
                    appealNumber={props.appealNumber}
                    appealDate={props.appealDate}
                    policyViolated={props.policyViolated}
                    isNewSubmission={props.isNewSubmission}
                />
            }
        </React.Fragment>
    )
}